export enum ShippingProviders {
  GOBOLT = 'gobolt',
  CANADA_POST = 'canadapost',
  CANADA_POST_3PL = 'canadapost3pl',
  CANPAR = 'canpar',
  CHASSEURS_COURRIER = 'chasseurscourrier',
  COURANT_PLUS = 'courantplus',
  GLS = 'gls',
  DHL = 'dhl',
  FEDEX = 'fedex',
  FEDEX_GROUND = 'fedexground',
  FEDEX_EXPRESS = 'fedexexpress',
  FLASHBOX = 'flashbox',
  NATIONEX = 'nationex',
  NATIONEXT2 = 'nationext2',
  PUROLATOR = 'purolator',
  SHIFT = 'shift',
  UPS = 'ups',
  UBER = 'uber',
  EEKO = 'eeko',
  RIVO = 'rivo',
  MULTILEG = 'multileg',
  AIR_CANADA = 'aircanada',
  INTELCOM = 'intelcom',
  UNIUNI = 'uniuni',
  SPRING = 'spring',
  APPLE_EXPRESS = 'appleexpress',
  TREXITY = 'trexity',
  TFORCE_LOGISTICS = 'tforcelogistics',
  MACHOOL_LOGISTICS = 'machoollogistics',
  LIVRAPIDE = 'livrapide',
  ICS_COURIER = 'icscourier',
  EVA = 'eva',
  DELIVRO = 'delivro',
  DEELEEO = 'deeleeo',
  DAYROSS = 'dayross',
  ULALA = 'ulala',
  MDX = 'mdx',
  LOOMIS_EXPRESS = 'loomisexpress',
  FREIGHT_AIR_CANADA = 'freightaircanada',
  FREIGHT_GLS = 'freightgls',
  GREEN_PICKUP = 'greenpickup',
  BOXKNIGHT = 'boxknight',
  CHRONO_EXPRESS = 'chronoexpress',
  GROUPE_MORNEAU = 'groupemorneau',
  ZIPPLY = 'zipply',
  CARGOJET = 'cargojet',
  FREIGHT_PUROLATOR = 'freightpurolator',
  ATS = 'ats',
  UNKNOWN = 'unknown',
}

export enum ShippingProviderName {
  CANADA_POST = 'Canada Post',
  CANADA_POST_3PL = 'Canada Post 3PL',
  CANPAR = 'Canpar Express',
  CHASSEURS_COURRIER = 'Chasseurs Courrier',
  GLS = 'GLS',
  DHL = 'DHL',
  FEDEX = 'FedEx',
  FEDEX_GROUND = 'FedEx Ground',
  FEDEX_EXPRESS = 'FedEx Express',
  FLASHBOX = 'FlashBox',
  NATIONEX = 'Nationex',
  PUROLATOR = 'Purolator',
  SHIFT = 'Shift Delivery',
  UPS = 'UPS',
  EEKO = 'EEKO',
  RIVO = 'Rivo',
  MULTILEG = 'multileg',
  AIR_CANADA = 'MultiLeg',
  INTELCOM = 'Intelcom | Dragonfly',
  UNIUNI = 'UniUni',
  SPRING = 'Spring',
  APPLE_EXPRESS = 'Apple Express',
  TREXITY = 'Trexity',
  TFORCE_LOGISTICS = 'TForce',
  MACHOOL_LOGISTICS = 'Machool Logistics',
  LIVRAPIDE = 'Livrapide',
  ICS_COURIER = 'ICS Courier',
  EVA = 'Eva',
  DELIVRO = 'Delivro',
  ULALA = 'Ulala',
  MDX = 'MDX Logistique',
  LOOMIS_EXPRESS = 'Loomis Express',
  DEELEEO = 'Deeleeo',
  CHRONO_EXPRESS = 'ChronoExpress',
  ZIPPLY = 'Zipply',
  GROUPE_MORNEAU = 'Groupe Morneau',
  UBER = 'Uber',
  UNKNOWN = 'Unknown Partner',

  // Freight Air Canada Cargo
  FREIGHT_AIR_CANADA = 'Air Canada Cargo (Freight)',
  DAYROSS = 'Day & Ross',
  FREIGHT_GLS = 'GLS Freight',
  CARGOJET = 'Cargojet',
  FREIGHT_PUROLATOR = 'Purolator Freight',
  ATS = 'ATS Healthcare',

  // TODO: Legacy providers. Remove once old shipment data archived (4266)
  GOBOLT = 'GoBolt',
  COURANT_PLUS = 'Courant Plus',
}

export enum TrackingEnabledShippingProvider {
  CANADA_POST = ShippingProviders.CANADA_POST,
  CANADA_POST_3PL = ShippingProviders.CANADA_POST_3PL,
  CANPAR = ShippingProviders.CANPAR,
  CHASSEURS_COURRIER = ShippingProviders.CHASSEURS_COURRIER,
  CHRONO_EXPRESS = ShippingProviders.CHRONO_EXPRESS,
  GLS = ShippingProviders.GLS,
  DHL = ShippingProviders.DHL,
  FEDEX = ShippingProviders.FEDEX,
  FLASHBOX = ShippingProviders.FLASHBOX,
  PUROLATOR = ShippingProviders.PUROLATOR,
  UPS = ShippingProviders.UPS,
  NATIONEX = ShippingProviders.NATIONEX,
  RIVO = ShippingProviders.RIVO,
  MULTILEG = ShippingProviders.MULTILEG,
  INTELCOM = ShippingProviders.INTELCOM,
  UNIUNI = ShippingProviders.UNIUNI,
  SPRING = ShippingProviders.SPRING,
  APPLE_EXPRESS = ShippingProviders.APPLE_EXPRESS,
  TREXITY = ShippingProviders.TREXITY,
  TFORCE_LOGISTICS = ShippingProviders.TFORCE_LOGISTICS,
  ICS_COURIER = ShippingProviders.ICS_COURIER,
  DELIVRO = ShippingProviders.DELIVRO,
  ULALA = ShippingProviders.ULALA,
  LOOMIS_EXPRESS = ShippingProviders.LOOMIS_EXPRESS,
  ZIPPLY = ShippingProviders.ZIPPLY,

  FREIGHT_AIR_CANADA = ShippingProviders.FREIGHT_AIR_CANADA,
  DAYROSS = ShippingProviders.DAYROSS,
  GROUPE_MORNEAU = ShippingProviders.GROUPE_MORNEAU,
  FREIGHT_PUROLATOR = ShippingProviders.FREIGHT_PUROLATOR,
}

export enum InsuranceProviders {
  MARSH = 'marsh',
  UPIC = 'upic',
}

export enum WMSProviders {
  EXTENSIV = 'extensiv',
}

export enum WMSProviderNames {
  EXTENSIV = 'Extensiv',
}

export enum FreightProviders {
  DAYROSS = 'dayross',
  FREIGHT_AIR_CANADA = 'freightaircanada',
  FREIGHT_GLS = 'freightgls',
  GROUPE_MORNEAU = 'groupemorneau',
  CARGOJET = 'cargojet',
  FREIGHT_PUROLATOR = 'freightpurolator',
}

export enum FreightProviderNames {
  DAYROSS = 'Day & Ross',
  FREIGHT_AIR_CANADA = 'Air Canada Cargo (Freight)',
  GROUPE_MORNEAU = 'Groupe Morneau',
  CARGOJET = 'Cargojet',
  FREIGHT_GLS = 'GLS Freight',
  FREIGHT_PUROLATOR = 'Purolator Freight',
}

export const TRACKING_ENABLED_SHIPPING_PROVIDERS = Object.values(TrackingEnabledShippingProvider);

// Couriers that can bill a shipment to a third-party courier account
export const THIRD_PARTY_BILLING_PROVIDERS: readonly ShippingProviders[] = [
  ShippingProviders.UPS,
  ShippingProviders.DHL,
  ShippingProviders.PUROLATOR,
  ShippingProviders.CANADA_POST,
  ShippingProviders.FEDEX,
  ShippingProviders.GLS,
  ShippingProviders.LOOMIS_EXPRESS,
];

export enum EcommerceProviders {
  SHOPIFY = 'shopify',
  WOOCOMMERCE = 'woocommerce',
  MAGENTO = 'magento',
  WIX = 'wix',
  ETSY = 'etsy',
  PANIERDACHAT = 'panierdachat',
  LIGHTSPEED = 'lightspeed',
  BIGCOMMERCE = 'bigcommerce',
  DVORE = 'dvore',
  SQUARESPACE = 'squarespace',
  TECHPOS = 'techpos',
  XCART = 'xcart',
  LEPANIERBLEU = 'lepanierbleu',
  LIGHTSPEED_E_SERIES = 'lightspeedeseries',
}

// Display names for EcommerceProviders
export enum EcommerceProviderNames {
  SHOPIFY = 'Shopify',
  LIGHTSPEED = 'Lightspeed',
  WOOCOMMERCE = 'WooCommerce',
  MAGENTO = 'Magento',
  WIX = 'Wix',
  ETSY = 'Etsy',
  BIGCOMMERCE = 'BigCommerce',
  DVORE = 'Dvore',
  SQUARESPACE = 'Squarespace',
  PANIERDACHAT = 'Panierdachat',
  TECHPOS = 'TechPOS',
  XCART = 'X-Cart',
  LEPANIERBLEU = 'LePanierBleu',
  LIGHTSPEED_E_SERIES = 'Lightspeed E-Series',
}
